import { render, staticRenderFns } from "./real-stories.vue?vue&type=template&id=d1494e18&scoped=true"
import script from "./real-stories.vue?vue&type=script&lang=js"
export * from "./real-stories.vue?vue&type=script&lang=js"
import style0 from "./real-stories.vue?vue&type=style&index=0&id=d1494e18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1494e18",
  null
  
)

export default component.exports